import { InferType, object, string } from 'yup';

const ForgotPasswordSchema = object({
  email: string().email('Email is invalid.').required('Email is required'),
});

export type ForgotPasswordSchemaType = InferType<typeof ForgotPasswordSchema>;

export { ForgotPasswordSchema };
